import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';
import '../styles/industries.css';

const Industries = () => {
  const { t } = useTranslation('industries');
  const { language } = useLanguage();

  const industries = [
    {
      title: t('cards.enterprise.title'),
      description: t('cards.enterprise.description'),
      tag: t('cards.enterprise.tag'),
      image: '/Images/industries/office.jpg',
      cta: { text: t('cards.enterprise.cta'), link: `/${language}/enterprise-ai` }
    },
    {
      title: t('cards.government.title'),
      description: t('cards.government.description'),
      tag: t('cards.government.tag'),
      image: '/Images/industries/government.jpg',
      cta: { text: t('cards.government.cta'), link: `/${language}/ai-governance` }
    },
    {
      title: t('cards.manufacturing.title'),
      description: t('cards.manufacturing.description'),
      tag: t('cards.manufacturing.tag'),
      image: '/Images/industries/manufacturing.jpg'
    },
    {
      title: t('cards.retail.title'),
      description: t('cards.retail.description'),
      tag: t('cards.retail.tag'),
      image: '/Images/industries/retail.jpg'
    },
    {
      title: t('cards.healthcare.title'),
      description: t('cards.healthcare.description'),
      tag: t('cards.healthcare.tag'),
      image: '/Images/industries/healthcare.jpg'
    },
    {
      title: t('cards.facilities.title'),
      description: t('cards.facilities.description'),
      tag: t('cards.facilities.tag'),
      image: '/Images/industries/facilities.jpg'
    }
  ];

  return (
    <div className="industries-page">
      <SEO 
        title="AI Solutions for Industries - Law Enforcement, Healthcare, Finance & More"
        description="EWANDS delivers AI solutions across industries: law enforcement AI, predictive AI for government, AI for healthcare, fintech AI, manufacturing, logistics, and enterprise offices across Malaysia and ASEAN."
        keywords="law enforcement AI Malaysia, AI solutions Malaysia, predictive AI government, AI for healthcare Malaysia, AI fintech solutions, AI manufacturing, AI logistics, AI government solutions, industry AI solutions Malaysia, AI implementation Malaysia"
        canonicalPath={`/${language}/industries`}
      />
      {/* Hero Section */}
      <section className="hero-section industries-hero">
        <div className="hero-background">
          <div className="gradient-layer"></div>
          <div className="particle-layer"></div>
          <div className="grid-overlay"></div>
          <div className="tech-lines"></div>
        </div>
        
        <div className="hero-content">
          <div className="container">
            <div className="hero-wrapper">
              <div className="tech-element tech-element-1"></div>
              <div className="tech-element tech-element-5"></div>
              <div className="tech-element tech-element-6"></div>
              <h1 className="hero-quote">
                <span className="quote-highlight">{t('hero.title')}</span><br />
                {t('hero.subtitle1')}<br />
                {t('hero.subtitle2')}
              </h1>
              <p className="hero-subtitle fade-in" style={{ animationDelay: '0.2s' }}>
                {t('hero.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Content */}
      <section className="capabilities-grid-section mb-5 pb-5">
        <div className="container">
          <div className="row g-4">
            {industries.map((industry, index) => (
              <div key={index} className="col-lg-6">
                <div className="capability-card-modern fade-in" style={{ animationDelay: `${0.3 + index * 0.1}s` }}>
                  <div className="industry-card-media" aria-hidden="true">
                    <img
                      className="industry-card-img"
                      src={industry.image}
                      alt={industry.title}
                      loading="lazy"
                    />
                    {/* <div className="ai-generated-overlay">AI-Generated</div> */}
                  </div>
                  <div className="card-tag">{industry.tag}</div>
                  <h3 className="capability-title-bold">{industry.title}</h3>
                  <div className="card-divider"></div>
                  <p className="capability-desc-text">{industry.description}</p>
                  {industry.cta && (
                    <div className="mt-4">
                      <Link to={industry.cta.link} className="hero-cta" style={{ marginTop: 0 }}>
                        {industry.cta.text}
                        <span className="cta-chevrons">
                          <span>›</span><span>›</span><span>›</span>
                        </span>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
